import { render, staticRenderFns } from "./OcrMobile.vue?vue&type=template&id=6ed95822&scoped=true"
import script from "./OcrMobile.vue?vue&type=script&lang=js"
export * from "./OcrMobile.vue?vue&type=script&lang=js"
import style0 from "./OcrMobile.vue?vue&type=style&index=0&id=6ed95822&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../and-iot-pre-checkin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed95822",
  null
  
)

export default component.exports